import PropTypes from "prop-types";
import * as React from "react";
import { Typography } from "../../../themeV2";
import css from "./AdvancedSettings.module.css";

export default function SettingsSection({
  title,
  description,
  error,
  children,
}) {
  return (
    <div
      className={[css.section, error ? css.sectionError : ""]
        .filter(Boolean)
        .join(" ")}
    >
      <Typography variant="title-md" as="h3" className={css.sectionTitle}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body-lg"
          color="variant"
          className={css.sectionDescription}
        >
          {description}
        </Typography>
      )}
      {children}
      {error && (
        <Typography
          variant="body-lg"
          color="error"
          className={css.sectionErrorText}
        >
          {error}
        </Typography>
      )}
    </div>
  );
}

SettingsSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  error: PropTypes.string,
  children: PropTypes.node,
};

export const Pair = ({ children }) => (
  <div className={css.pair}>{children}</div>
);

Pair.propTypes = {
  children: PropTypes.node,
};

export const SearchPanel = ({ children }) => (
  <div className={css.searchPanel}>{children}</div>
);

SearchPanel.propTypes = {
  children: PropTypes.node,
};

export const AccessRow = ({ children }) => (
  <div className={css.accessRow}>{children}</div>
);

AccessRow.propTypes = {
  children: PropTypes.node,
};
